const OsUtils = {}

OsUtils.getBrowserName = () => {
  // Lấy thông tin user agent
  var userAgent = navigator.userAgent;

  let browserName = ''

  // Kiểm tra trình duyệt
  if (userAgent.indexOf("Firefox") !== -1) {
    browserName = 'Firefox'
  } else if (userAgent.indexOf("Edge") !== -1 || userAgent.indexOf("Edg") !== -1) {
    browserName = 'Edge'
  } else if (userAgent.indexOf("Opera") !== -1 || userAgent.indexOf("OPR") !== -1) {
    browserName = 'Opera'
  } else if (userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1) {
    browserName = 'Internet Explorer'
  } else if (userAgent.indexOf("Chrome") !== -1) {
    browserName = 'Chrome'
  } else if (userAgent.indexOf("Safari") !== -1) {
    browserName = 'Safari'
  } else {
    browserName = 'Unknown Browser'
  }

  return browserName
}

OsUtils.getOsName = () => {
  let osName = 'Unknown OS'

  // Lấy thông tin user agent
  var userAgent = navigator.userAgent;
  // Biến đổi thành chuỗi chữ thường để kiểm tra dễ dàng
  var lowerUserAgent = userAgent.toLowerCase();
  // Kiểm tra tên và phiên bản hệ điều hành
  if (lowerUserAgent.includes("windows")) {
    console.log("Hệ điều hành: Windows");
    // Kiểm tra phiên bản Windows
    if (lowerUserAgent.includes("windows nt 10")) {
      osName = 'Windows 10'
    } else if (lowerUserAgent.includes("windows nt 6.3")) {
      osName = 'Windows 8.1'
    } else if (lowerUserAgent.includes("windows nt 6.2")) {
      osName = 'Windows 8'
    } else {
      osName = 'Windows'
    }
    // và tiếp tục cho các phiên bản khác 
  } else if (lowerUserAgent.includes("mac")) {
    console.log("Hệ điều hành: macOS");
    osName = 'macOS'
    // Kiểm tra phiên bản macOS
    // Các điều kiện tương tự có thể được thêm vào cho các phiên bản khác
  } else if (lowerUserAgent.includes("linux")) {
    osName = 'Linux'
  } else if (lowerUserAgent.includes("android")) {
    osName = 'Android'
    // Kiểm tra phiên bản Android
  } else if (lowerUserAgent.includes("iphone") || lowerUserAgent.includes("ipad") || lowerUserAgent.includes("ipod")) {
    osName = 'iOS'
    // Kiểm tra phiên bản iOS
  } else {
    console.log("Hệ điều hành không xác định");
  }

  return osName
}

OsUtils.getDeviceName = () => {
  return `${OsUtils.getOsName()} (${OsUtils.getBrowserName()})`
}



export default OsUtils
